"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Personenart = _interopRequireDefault(require("./Personenart"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Besteller model module.
 * @module model/Besteller
 * @version 1.0.44
 */
var Besteller = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Besteller</code>.
   * Bei der Bestellung übermittelte Kundendaten
   * @alias module:model/Besteller
   * @param gebDatKunde {Date} Geburtstag des Kunden (GEB_DAT) konvertiert
   * @param gebOrtKunde {String} Geburtsort des Kunden (KUNDE_GEBORT)
   * @param gebietsansaessigerKz {Number} Ist gebietsansässig? 0=nein 1=ja (DEV_INL_KZ bzw DEVINL_KZ) konvertiert
   * @param kundeOrt {String} Wohnort des Kunden (KUNDE_ORT bzw PLZ_ORT berechnet)
   * @param kundenStrasse1 {String} Adress-Straße des Kunden (STR1)
   * @param kundenStrasse2 {String} weitere Adress-Straße des Kunden, falls zu lang für kundenStrasse1 (STR2)
   * @param kundenkonto {String} IBAN des Kunden (IBAN)
   * @param kundenname1 {String} Name des Kunden (NAME1)
   * @param kundenname2 {String} weiterer Name des Kunden, falls zulang für kundenname1 (NAME2)
   * @param lieferadressennummer {Number} Nummer der Filiale zum Liefern (LIEFER)
   * @param nationalitaetKunde {String} 3 Buchstabiger ISO Währungscode
   * @param persArt {module:model/Personenart} 
   * @param plz {String} Postleitzahl des Kunden (KUNDE_PLZ bzw. PLZ_ORT berechnet)
   */
  function Besteller(gebDatKunde, gebOrtKunde, gebietsansaessigerKz, kundeOrt, kundenStrasse1, kundenStrasse2, kundenkonto, kundenname1, kundenname2, lieferadressennummer, nationalitaetKunde, persArt, plz) {
    _classCallCheck(this, Besteller);
    Besteller.initialize(this, gebDatKunde, gebOrtKunde, gebietsansaessigerKz, kundeOrt, kundenStrasse1, kundenStrasse2, kundenkonto, kundenname1, kundenname2, lieferadressennummer, nationalitaetKunde, persArt, plz);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Besteller, null, [{
    key: "initialize",
    value: function initialize(obj, gebDatKunde, gebOrtKunde, gebietsansaessigerKz, kundeOrt, kundenStrasse1, kundenStrasse2, kundenkonto, kundenname1, kundenname2, lieferadressennummer, nationalitaetKunde, persArt, plz) {
      obj['gebDatKunde'] = gebDatKunde;
      obj['gebOrtKunde'] = gebOrtKunde;
      obj['gebietsansaessigerKz'] = gebietsansaessigerKz;
      obj['kundeOrt'] = kundeOrt;
      obj['kundenStrasse1'] = kundenStrasse1;
      obj['kundenStrasse2'] = kundenStrasse2;
      obj['kundenkonto'] = kundenkonto;
      obj['kundenname1'] = kundenname1;
      obj['kundenname2'] = kundenname2;
      obj['lieferadressennummer'] = lieferadressennummer;
      obj['nationalitaetKunde'] = nationalitaetKunde;
      obj['persArt'] = persArt;
      obj['plz'] = plz;
    }

    /**
     * Constructs a <code>Besteller</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Besteller} obj Optional instance to populate.
     * @return {module:model/Besteller} The populated <code>Besteller</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Besteller();
        if (data.hasOwnProperty('blzGP')) {
          obj['blzGP'] = _ApiClient.default.convertToType(data['blzGP'], 'String');
        }
        if (data.hasOwnProperty('gebDatKunde')) {
          obj['gebDatKunde'] = _ApiClient.default.convertToType(data['gebDatKunde'], 'Date');
        }
        if (data.hasOwnProperty('gebOrtKunde')) {
          obj['gebOrtKunde'] = _ApiClient.default.convertToType(data['gebOrtKunde'], 'String');
        }
        if (data.hasOwnProperty('gebietsansaessigerKz')) {
          obj['gebietsansaessigerKz'] = _ApiClient.default.convertToType(data['gebietsansaessigerKz'], 'Number');
        }
        if (data.hasOwnProperty('kundeOrt')) {
          obj['kundeOrt'] = _ApiClient.default.convertToType(data['kundeOrt'], 'String');
        }
        if (data.hasOwnProperty('kundenStrasse1')) {
          obj['kundenStrasse1'] = _ApiClient.default.convertToType(data['kundenStrasse1'], 'String');
        }
        if (data.hasOwnProperty('kundenStrasse2')) {
          obj['kundenStrasse2'] = _ApiClient.default.convertToType(data['kundenStrasse2'], 'String');
        }
        if (data.hasOwnProperty('kundenkonto')) {
          obj['kundenkonto'] = _ApiClient.default.convertToType(data['kundenkonto'], 'String');
        }
        if (data.hasOwnProperty('kundenname1')) {
          obj['kundenname1'] = _ApiClient.default.convertToType(data['kundenname1'], 'String');
        }
        if (data.hasOwnProperty('kundenname2')) {
          obj['kundenname2'] = _ApiClient.default.convertToType(data['kundenname2'], 'String');
        }
        if (data.hasOwnProperty('lieferadressennummer')) {
          obj['lieferadressennummer'] = _ApiClient.default.convertToType(data['lieferadressennummer'], 'Number');
        }
        if (data.hasOwnProperty('lieferfilialadresse')) {
          obj['lieferfilialadresse'] = _ApiClient.default.convertToType(data['lieferfilialadresse'], 'String');
        }
        if (data.hasOwnProperty('lieferfilialname')) {
          obj['lieferfilialname'] = _ApiClient.default.convertToType(data['lieferfilialname'], 'String');
        }
        if (data.hasOwnProperty('nationalitaetKunde')) {
          obj['nationalitaetKunde'] = _ApiClient.default.convertToType(data['nationalitaetKunde'], 'String');
        }
        if (data.hasOwnProperty('persArt')) {
          obj['persArt'] = _Personenart.default.constructFromObject(data['persArt']);
        }
        if (data.hasOwnProperty('plz')) {
          obj['plz'] = _ApiClient.default.convertToType(data['plz'], 'String');
        }
        if (data.hasOwnProperty('namenszusatz')) {
          obj['namenszusatz'] = _ApiClient.default.convertToType(data['namenszusatz'], 'String');
        }
        if (data.hasOwnProperty('vorname')) {
          obj['vorname'] = _ApiClient.default.convertToType(data['vorname'], 'String');
        }
        if (data.hasOwnProperty('nachname')) {
          obj['nachname'] = _ApiClient.default.convertToType(data['nachname'], 'String');
        }
        if (data.hasOwnProperty('liefername')) {
          obj['liefername'] = _ApiClient.default.convertToType(data['liefername'], 'String');
        }
        if (data.hasOwnProperty('adressenId')) {
          obj['adressenId'] = _ApiClient.default.convertToType(data['adressenId'], 'Number');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Besteller</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Besteller</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(Besteller.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['blzGP'] && !(typeof data['blzGP'] === 'string' || data['blzGP'] instanceof String)) {
        throw new Error("Expected the field `blzGP` to be a primitive type in the JSON string but got " + data['blzGP']);
      }
      // ensure the json data is a string
      if (data['gebOrtKunde'] && !(typeof data['gebOrtKunde'] === 'string' || data['gebOrtKunde'] instanceof String)) {
        throw new Error("Expected the field `gebOrtKunde` to be a primitive type in the JSON string but got " + data['gebOrtKunde']);
      }
      // ensure the json data is a string
      if (data['kundeOrt'] && !(typeof data['kundeOrt'] === 'string' || data['kundeOrt'] instanceof String)) {
        throw new Error("Expected the field `kundeOrt` to be a primitive type in the JSON string but got " + data['kundeOrt']);
      }
      // ensure the json data is a string
      if (data['kundenStrasse1'] && !(typeof data['kundenStrasse1'] === 'string' || data['kundenStrasse1'] instanceof String)) {
        throw new Error("Expected the field `kundenStrasse1` to be a primitive type in the JSON string but got " + data['kundenStrasse1']);
      }
      // ensure the json data is a string
      if (data['kundenStrasse2'] && !(typeof data['kundenStrasse2'] === 'string' || data['kundenStrasse2'] instanceof String)) {
        throw new Error("Expected the field `kundenStrasse2` to be a primitive type in the JSON string but got " + data['kundenStrasse2']);
      }
      // ensure the json data is a string
      if (data['kundenkonto'] && !(typeof data['kundenkonto'] === 'string' || data['kundenkonto'] instanceof String)) {
        throw new Error("Expected the field `kundenkonto` to be a primitive type in the JSON string but got " + data['kundenkonto']);
      }
      // ensure the json data is a string
      if (data['kundenname1'] && !(typeof data['kundenname1'] === 'string' || data['kundenname1'] instanceof String)) {
        throw new Error("Expected the field `kundenname1` to be a primitive type in the JSON string but got " + data['kundenname1']);
      }
      // ensure the json data is a string
      if (data['kundenname2'] && !(typeof data['kundenname2'] === 'string' || data['kundenname2'] instanceof String)) {
        throw new Error("Expected the field `kundenname2` to be a primitive type in the JSON string but got " + data['kundenname2']);
      }
      // ensure the json data is a string
      if (data['lieferfilialadresse'] && !(typeof data['lieferfilialadresse'] === 'string' || data['lieferfilialadresse'] instanceof String)) {
        throw new Error("Expected the field `lieferfilialadresse` to be a primitive type in the JSON string but got " + data['lieferfilialadresse']);
      }
      // ensure the json data is a string
      if (data['lieferfilialname'] && !(typeof data['lieferfilialname'] === 'string' || data['lieferfilialname'] instanceof String)) {
        throw new Error("Expected the field `lieferfilialname` to be a primitive type in the JSON string but got " + data['lieferfilialname']);
      }
      // ensure the json data is a string
      if (data['nationalitaetKunde'] && !(typeof data['nationalitaetKunde'] === 'string' || data['nationalitaetKunde'] instanceof String)) {
        throw new Error("Expected the field `nationalitaetKunde` to be a primitive type in the JSON string but got " + data['nationalitaetKunde']);
      }
      // ensure the json data is a string
      if (data['plz'] && !(typeof data['plz'] === 'string' || data['plz'] instanceof String)) {
        throw new Error("Expected the field `plz` to be a primitive type in the JSON string but got " + data['plz']);
      }
      // ensure the json data is a string
      if (data['namenszusatz'] && !(typeof data['namenszusatz'] === 'string' || data['namenszusatz'] instanceof String)) {
        throw new Error("Expected the field `namenszusatz` to be a primitive type in the JSON string but got " + data['namenszusatz']);
      }
      // ensure the json data is a string
      if (data['vorname'] && !(typeof data['vorname'] === 'string' || data['vorname'] instanceof String)) {
        throw new Error("Expected the field `vorname` to be a primitive type in the JSON string but got " + data['vorname']);
      }
      // ensure the json data is a string
      if (data['nachname'] && !(typeof data['nachname'] === 'string' || data['nachname'] instanceof String)) {
        throw new Error("Expected the field `nachname` to be a primitive type in the JSON string but got " + data['nachname']);
      }
      // ensure the json data is a string
      if (data['liefername'] && !(typeof data['liefername'] === 'string' || data['liefername'] instanceof String)) {
        throw new Error("Expected the field `liefername` to be a primitive type in the JSON string but got " + data['liefername']);
      }
      return true;
    }
  }]);
}();
Besteller.RequiredProperties = ["gebDatKunde", "gebOrtKunde", "gebietsansaessigerKz", "kundeOrt", "kundenStrasse1", "kundenStrasse2", "kundenkonto", "kundenname1", "kundenname2", "lieferadressennummer", "nationalitaetKunde", "persArt", "plz"];

/**
 * Bankleitzahl des Kunden (BLZ)
 * @member {String} blzGP
 */
Besteller.prototype['blzGP'] = undefined;

/**
 * Geburtstag des Kunden (GEB_DAT) konvertiert
 * @member {Date} gebDatKunde
 */
Besteller.prototype['gebDatKunde'] = undefined;

/**
 * Geburtsort des Kunden (KUNDE_GEBORT)
 * @member {String} gebOrtKunde
 */
Besteller.prototype['gebOrtKunde'] = undefined;

/**
 * Ist gebietsansässig? 0=nein 1=ja (DEV_INL_KZ bzw DEVINL_KZ) konvertiert
 * @member {Number} gebietsansaessigerKz
 */
Besteller.prototype['gebietsansaessigerKz'] = undefined;

/**
 * Wohnort des Kunden (KUNDE_ORT bzw PLZ_ORT berechnet)
 * @member {String} kundeOrt
 */
Besteller.prototype['kundeOrt'] = undefined;

/**
 * Adress-Straße des Kunden (STR1)
 * @member {String} kundenStrasse1
 */
Besteller.prototype['kundenStrasse1'] = undefined;

/**
 * weitere Adress-Straße des Kunden, falls zu lang für kundenStrasse1 (STR2)
 * @member {String} kundenStrasse2
 */
Besteller.prototype['kundenStrasse2'] = undefined;

/**
 * IBAN des Kunden (IBAN)
 * @member {String} kundenkonto
 */
Besteller.prototype['kundenkonto'] = undefined;

/**
 * Name des Kunden (NAME1)
 * @member {String} kundenname1
 */
Besteller.prototype['kundenname1'] = undefined;

/**
 * weiterer Name des Kunden, falls zulang für kundenname1 (NAME2)
 * @member {String} kundenname2
 */
Besteller.prototype['kundenname2'] = undefined;

/**
 * Nummer der Filiale zum Liefern (LIEFER)
 * @member {Number} lieferadressennummer
 */
Besteller.prototype['lieferadressennummer'] = undefined;

/**
 * Lieferadresse der Filiale (LIEFER_STR1 + LIEFER_STR2 + LIEFER_PLZ + LIEFER_ORT)
 * @member {String} lieferfilialadresse
 */
Besteller.prototype['lieferfilialadresse'] = undefined;

/**
 * Name der Filiale (LIEFER_NAME1+LIEFER_NAME2)
 * @member {String} lieferfilialname
 */
Besteller.prototype['lieferfilialname'] = undefined;

/**
 * 3 Buchstabiger ISO Währungscode
 * @member {String} nationalitaetKunde
 */
Besteller.prototype['nationalitaetKunde'] = undefined;

/**
 * @member {module:model/Personenart} persArt
 */
Besteller.prototype['persArt'] = undefined;

/**
 * Postleitzahl des Kunden (KUNDE_PLZ bzw. PLZ_ORT berechnet)
 * @member {String} plz
 */
Besteller.prototype['plz'] = undefined;

/**
 * Erweiterund des Namens
 * @member {String} namenszusatz
 */
Besteller.prototype['namenszusatz'] = undefined;

/**
 * Vorname des Kunden
 * @member {String} vorname
 */
Besteller.prototype['vorname'] = undefined;

/**
 * Nachname oder Firmenname des Kunden 
 * @member {String} nachname
 */
Besteller.prototype['nachname'] = undefined;

/**
 * Name bei der Lieferadresse des Kunden   
 * @member {String} liefername
 */
Besteller.prototype['liefername'] = undefined;

/**
 * ID der Lieferadresse, wenn ausgewählt
 * @member {Number} adressenId
 */
Besteller.prototype['adressenId'] = undefined;
var _default = exports.default = Besteller;